import React from 'react'
import { normalizeIHSVictimData } from '../../utilities'
import { ReviewIHSVictim } from './ReviewIHSVictim'

export const ReviewIHSVictims = ({ values, ...props }) => {
  const victims = normalizeIHSVictimData(values, 9)
  const singleVictim = victims.length == 1

  return victims.map((victim, index) => {
    const editFieldName = `victim_first_name_${index}`
    const victimProps = {
      ...victim,
      ...props,
      editFieldName
    }
    return (
      <section key={editFieldName}>
        {singleVictim ? <h2>Victim</h2> : <h2>Victim {index + 1}</h2>}
        <ReviewIHSVictim {...victimProps} />
      </section>
    )
  })
}
